import { AuthFlowError } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { confirmEmailChange } from 'shared/services/backend-api';

export const useConfirmEmailChangeMutation = () =>
  useMutation<string, AuthFlowError, string>({
    mutationFn: (token) => confirmEmailChange(token),
  });
